import { render, staticRenderFns } from "./UnTabsUiVerticalUpdate.vue?vue&type=template&id=489afc8b&lang=pug&"
import script from "./UnTabsUiVerticalUpdate.vue?vue&type=script&lang=js&"
export * from "./UnTabsUiVerticalUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports